// The filter bar of the global Aktivitätsprotokoll as feed request fields
// (AuditFeedRequest in api2/src/modules/operators/operators.types.ts). The server ANDs them.
//
// filters: { userId?, actorEmail?, from?: 'YYYY-MM-DD', to?: 'YYYY-MM-DD', events?: string[], search?: string }

// a picked day in the admin's own time zone, as the first or last millisecond of that day
function dayBoundary(day, end) {
	const [ year, month, date ] = day.split('-').map(Number)
	return (end ? new Date(year, month - 1, date, 23, 59, 59, 999) : new Date(year, month - 1, date)).toISOString()
}

export function auditFilterRequest(filters) {
	const request = {}
	if (filters.userId) request.userId = filters.userId
	if (filters.actorEmail) request.actorEmail = filters.actorEmail
	if (filters.from) request.from = dayBoundary(filters.from, false)
	if (filters.to) request.to = dayBoundary(filters.to, true)
	if (filters.events?.length) request.events = [ ...filters.events ]
	if (filters.search?.trim()) request.search = filters.search.trim()
	return request
}

export function hasAuditFilters(filters) {
	return Object.keys(auditFilterRequest(filters)).length > 0
}
